import React from "react";
import { AssignmentOutlined, CalendarMonthOutlined, ArchiveOutlined, GroupOutlined, PrintOutlined, Settings, TranslateOutlined, Archive } from "@mui/icons-material";

import { MenuRoute } from "./toolympus/components/frame";
import { SystemSubmenu } from "./toolympus/components/Contests/SystemSubmenu";
import { CMS } from "./components/CMS";
import { LocalizedMessagesX } from "./components/LocalizedMessages";
import { Forms } from "./components/Forms/Forms";
import { CalendarAdminPage, CalendarArchivePage, CalendarCoorgPage, EventAdminPage, EventArchivePage, EventCoorgPage } from "./components/Riac/Calendar";
import { AttendeesList } from "./components/Riac/Attendees";
import { SnapshotsManagement } from "./components/Settings/SnapshotsManagement";

const isAdmin = (roles: string[]) => roles.includes("admin");
const isCoorg = (roles: string[]) => roles.includes("coorganizer");

const InnerRoutes: MenuRoute[] = [
  {
    path: "/events/:id",
    title: "Events",
    hidden: true,
    component: EventAdminPage,
  },
  {
    path: "/events",
    title: "Events",
    icon: <CalendarMonthOutlined />,
    component: CalendarAdminPage,
    resolveHidden: isAdmin,
  },
  {
    path: "/archive-events/:id",
    title: "Archive",
    hidden: true,
    component: EventArchivePage,
  },
  {
    path: "/archive-events",
    title: "Archive",
    icon: <ArchiveOutlined />,
    component: CalendarArchivePage,
    resolveHidden: isAdmin,
  },
  {
    path: "/attendees",
    title: "Attendees",
    icon: <GroupOutlined />,
    component: AttendeesList,
    resolveHidden: isAdmin,
  },
  {
    path: "/my-events/:id",
    title: "Events",
    hidden: true,
    component: EventCoorgPage,
  },
  {
    path: "/my-events",
    title: "My Events",
    icon: <CalendarMonthOutlined />,
    component: CalendarCoorgPage,
    resolveHidden: isCoorg,
  },


  // {
  //   path: "/settings",
  //   title: "Settings",
  //   icon: <Settings />,
  //   component: SettingsGeneral,
  //   resolveHidden: isAdmin,
  // },

  {
    path: "/cms",
    title: "CMS",
    icon: <PrintOutlined />,
    component: CMS,
    resolveHidden: isAdmin,
  },
  {
    path: "/forms",
    title: "Forms",
    icon: <AssignmentOutlined />,
    component: Forms,
    resolveHidden: isAdmin,
  },
  {
    path: "/messages",
    title: "Messages",
    icon: <TranslateOutlined />,
    component: LocalizedMessagesX,
    resolveHidden: isAdmin,
  },

  { 
      path: '/system',
      title: 'System',
      resolveHidden: isAdmin,
      icon: <Settings />,
      component: () => (
          <SystemSubmenu
              emails={{ apiPath: "/emails" }}
              users={{ allowInvites: true, allowPaswordReset: true, allowPaswordChange: true, twoFactorAuthEnabled: true }}
              notificationTasks={{ apiPath: "/api/notifications/task", emailsApiPath: "/api/emails", emailsPagePath: "/system/emails" }}
              pages={[{
                  apiPath: "/api/page",
                  key: "all",
                  label: "All",
              }]}
              queryConsole={{}}
              apiTokens={{ apiPath: "/api/apitoken" }}
                extraItems={[
                    {
                        key: "snapshots",
                        label: "Snapshots",
                        icon: <Archive />,
                        items: [{ key: "snapshots", label: "", component: SnapshotsManagement }]
                    },
                    // {
                    //     key: "documentation",
                    //     label: "Documentation",
                    //     icon: <InfoOutlined />,
                    //     items: [{ key: "documentation", label: "", component: Documentation }]
                    // }
                ]}
          />),
  },
];

export default InnerRoutes;